import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Table, Popover, notification, message, Input, Form, Grid, Card, Select, Space } from 'antd'
import { RightOutlined, MenuOutlined } from '@ant-design/icons'

import Main from '../components/Main'
import {
  CLONE_UPDATE,
  CLONES_DISCOVER,
  CLONES_GET,
  requestToServer,
  getLocalData
} from '../lib/helper'

import { mainColor } from '../config'
import { dueTag, fmtDay } from '../lib/billing'   // Task007

// Task007: filtro de cobro de la lista. `due` lo calcula el backend (/clone/get-all)
const BILLING_FILTERS = [
  { value: 'all',       label: 'Cobro: todos',     match: c => true },
  { value: 'actions',   label: 'Requieren acción', match: c => !!( c.due && c.due.needsAction ) },
  { value: 'overdue',   label: 'Vencidos',         match: c => !!c.due && ['overdue', 'suspend_now'].includes(c.due.status) },
  { value: 'soon',      label: 'Por vencer',       match: c => !!c.due && ['due_today', 'due_soon'].includes(c.due.status) },
  { value: 'suspended', label: 'Suspendidos',      match: c => !!c.due && ['suspended', 'delete_soon'].includes(c.due.status) },
  { value: 'setup',     label: 'Sin configurar',   match: c => !!( c.due && c.due.needsSetup ) }
]


const SearchBox = ({value, onChange}) => {
  return(
    <Input
      style={{ minWidth: 140 }}   // Task007: en celular se achicaba a ~75px
      onChange={ onChange }
       allowClear value={value}
    />
  )
}


export default function Home() {

  const [clients, setClients] = useState([])
  const [search, setSearch] = useState('')
  const [billingFilter, setBillingFilter] = useState('all')   // Task007

  const history = useHistory()

  // pantallas < 576px (breakpoint 'sm' de antd) muestran tarjetas en vez de tabla
  const screens = Grid.useBreakpoint()
  const isMobile = !screens.sm

  const getClients = () => {
    requestToServer({}, CLONES_GET).then(r => {
      setClients(r.clones)
    }).catch(()=>{})
  }

  // Task007: misma búsqueda de antes (nombre de plataforma o id de suscripción), ahora como función pura. La lista que se
  // muestra se deriva de clients + búsqueda + filtro de cobro: antes era un estado aparte (clientsDisplayed) que había que
  // recalcular a mano en cada cambio, y con dos filtros se desincroniza fácil.
  const matchesSearch = (client) => {
    let aSearch = search.toLowerCase()
    let selected = false
    if ( client.platformName.toLowerCase().indexOf( aSearch ) !== -1 ) { selected = true } // the same for id-subscription
    if ( client.subscriptionId ) {
      if ( client.subscriptionId.toLowerCase().indexOf( aSearch ) !== -1 ) { selected = true } // the same for id-subscription
    }
    return selected
  }
  const billingMatch = BILLING_FILTERS.find( f => f.value === billingFilter ).match
  const clientsDisplayed = clients.filter( c => matchesSearch(c) && billingMatch(c) )
  // Task007: contador de la barra de botones. No hay cron que avise, así que tiene que verse
  const actionsCount = clients.filter( c => c.due && c.due.needsAction ).length

  useEffect(() => {

    let localData = getLocalData()
    if ( localData && localData.token ) {
      getClients()
    } else {
      history.push('/login')
    }
  }, [])

  let extraButtons = [
    {
      // Task007: el número cuenta los clones que requieren acción (vencidos, por vencer sin cobro enviado, por eliminar…)
      name: actionsCount > 0
        ? <span style={{color:'#cf1322', fontWeight:'bold'}}>Cobros ({actionsCount})</span>
        : 'Cobros',
      action: () => history.push('/cobros')
    },
    {
      name: 'Leads',   // Task036
      action: () => history.push('/leads')
    },
    {
      name: 'Logs',
      action: () => history.push('/logs')
    },
    {
      name: 'Descubrir',
      action: () => {
        requestToServer({}, CLONES_DISCOVER).then(r => {
          getClients()
          notification.info({message:'actualizado'})
        }).catch(()=>{})
      }
    }
  ]

  let columns = [
    {
      title : '',
      key: 'actions',
      render: (text, record, index) => {
        return(
          <Popover
            content={<OptionsAction record={record} />}
            title={record.platformName}
            trigger="click"
          >
            <MenuOutlined style={{color:mainColor}}
            />
          </Popover>
        )
      }
    },
    {
      title : 'Nombre',
      key: 'platformName',
      dataIndex: 'platformName'
    },
    {
      // Task007: estado de cobro y orden por fecha de vencimiento (los sin fecha van al final)
      title : 'Cobro',
      key: 'billing',
      sorter: (a, b) => (a.nextDueDate || '9999-99-99').localeCompare(b.nextDueDate || '9999-99-99'),
      render: (text, record) => (
        <span>{dueTag(record.due)}{ record.nextDueDate && <span style={{color:'#888'}}> {fmtDay(record.nextDueDate)}</span> }</span>
      )
    },
    {
      title : 'Multi',
      key: 'isMultiStore',
      render: (text, record, index) => {
        if (record.isMultiStore == null ) {
          return('')
        } else if (record.isMultiStore) {
          return('multi')
        } else {
          return('mb')
        }
      }
    },

    {
      title : 'Up',
      key: 'online',
      render: (text, record, index) => {
        let styles = {color:'white', paddingLeft:'4px', borderRadius:'3px'}
        if ( record.online ) {
          styles.backgroundColor = mainColor
        } else {
          styles.backgroundColor = 'red'
        }

        return (
          <div style={styles}>
            {record.backendVersion}
          </div>
        )
      }
    },
    {
      title : 'Clientes',
      key: 'customers',
      dataIndex: 'customers'
    },
    {
      title : 'Canjeados',
      key: 'redeemeds',
      dataIndex: 'redeemeds'
    },
    {
      title : 'Canjes',
      key: 'redeemedsLimit',
      dataIndex: 'redeemedsLimit'
    },
    
  ]

  const OptionsAction = ({record}) => {

    let { platformName } = record

    return(
      <div>
        <Button
          onClick={()=>{
            requestToServer({platformName}, CLONE_UPDATE).then(r => {
              getClients()
              message.info('actualizado: ' + platformName)
            }).catch(()=>{})
          }}
        >actualizar</Button>
        <Button
          onClick={ ()=>history.push('/clone/' + platformName ) }
        >ver</Button>
      </div>
    )
  }

  // tarjeta equivalente a una fila de la tabla, para pantallas chicas
  const CloneCard = ({record}) => {

    let upStyles = {color:'white', padding:'0 4px', borderRadius:'3px', display:'inline-block'}
    upStyles.backgroundColor = record.online ? mainColor : 'red'

    let multiLabel = record.isMultiStore == null ? '' : (record.isMultiStore ? 'multi' : 'mb')

    return(
      <Card
        size='small'
        style={{marginBottom:'10px'}}
        title={record.platformName}
        extra={
          <Popover
            content={<OptionsAction record={record} />}
            title={record.platformName}
            trigger="click"
          >
            <MenuOutlined style={{color:mainColor}} />
          </Popover>
        }
      >
        <div>
          <span style={upStyles}>{record.backendVersion}</span>
          { multiLabel && <span style={{marginLeft:'8px'}}>{multiLabel}</span> }
        </div>
        {/* Task007 */}
        <div>{dueTag(record.due)}{ record.nextDueDate && <span style={{color:'#888'}}> {fmtDay(record.nextDueDate)}</span> }</div>
        <div>Clientes: {record.customers}</div>
        <div>Canjeados: {record.redeemeds}</div>
        <div>Canjes: {record.redeemedsLimit}</div>
      </Card>
    )
  }


  return (
    <Main
      pageHeader={{ title:'' , backIcon: false, extraButtons }}
      subTitle={<Space>
        <SearchBox value={search} onChange={ e => setSearch(e.target.value) }/>
        <Select value={billingFilter} onChange={setBillingFilter} style={{width: 170}}
          options={BILLING_FILTERS.map( f => ({ value: f.value, label: f.label }) )} />
      </Space>}
    >

      { isMobile
        ? clientsDisplayed.map(record => <CloneCard key={record.id} record={record} />)
        : <Table columns={columns} dataSource={clientsDisplayed} rowKey='id' size='small' pagination={{pageSize: 50}}/>
      }
    </Main>
  )
}